const en = {
  found: 'found',
  item: 'item',
  popup: 'Input the name of the bias or the part of its description',
  placeholder: 'Search',
  placeholderFull: 'Search Biases',
};

export default en;
